import DashboardHome from "../pages/admin/DashboardHome";
import PatientForm from "../components/admin/PatientForm";
import PatientList from "../pages/admin/PatientList";
import Registration from "../components/admin/Registration";
import UpdatePatient from "../components/admin/UpdatePatient";
import ConstanteForm from "../components/admin/ConstanteForm";
import ConstanteRegistration from "../components/admin/ConstanteRegistration";
import ConstanteView from "../components/admin/ConstanteView";
import ConstanteUpdate from "../components/admin/ConstanteUpdate";
import AdminAccountUpdate from "../components/admin/AdminAccountUpdate";
import PatientAccount from "../components/admin/PatientAccount";
import PatientAccountRegistration from "../components/admin/PatientAccountRegistration";
import PatientAccountView from "../components/admin/PatientAccountView";
import PatientAccountUpdate from "../components/admin/PatientAccountUpdate";
import AdminAccount from "../pages/admin/AdminAccount";
import AdminAccountView from "../pages/admin/AdminAccountView";
import AdminAccountRegistration from "../pages/admin/AdminAccountRegistration";
import DoctorAccount from "../components/admin/DoctorAccount";
import DoctorAccountRegistration from "../components/admin/DoctorAccountRegistration";
import DoctorAccountUpdate from "../components/admin/DoctorAccountUpdate";
import DoctorAccountView from "../components/admin/DoctorAccountView";
import ConsultationWizardWrapper from "../components/consultation/ConsultationWizardWrapper";
// import RecordView from "../pages/admin/RecordView";
import RecordView from "../components/admin/RecordView";

// 🔥 CORRECTION : Import du RecordForm ADMIN au lieu de doctor
import RecordForm from "../components/admin/RecordForm";
// import RecordForm from "../components/doctor/RecordForm";
import RecordUpdate from "../components/doctor/RecordUpdate";

// 🔥 CORRECTION : Import du RecordUpdate ADMIN au lieu de doctor
// import RecordUpdate from "../components/admin/RecordUpdate";

export const sharedAdminRoutes = [
  { path: "accueil", element: <DashboardHome /> },
  { path: "patients", element: <PatientList /> },
  { path: "patient", element: <PatientForm /> },
  { path: "patient/new", element: <Registration /> },
  { path: "patient/view/:id", element: <PatientAccountView /> },
  { path: "patient/edit/:id", element: <UpdatePatient /> },
  { path: "constante", element: <ConstanteForm /> },
  { path: "constante/new", element: <ConstanteRegistration /> },
  { path: "constante/view/:id", element: <ConstanteView /> },
  { path: "constante/edit/:id", element: <ConstanteUpdate /> },
  { path: "account/patient", element: <PatientAccount /> },
  { path: "account/patient/new", element: <PatientAccountRegistration /> },
  { path: "account/patient/view/:id", element: <PatientAccountView /> },
  { path: "account/patient/edit/:id", element: <PatientAccountUpdate /> },
  { path: "account/admin", element: <AdminAccount /> },
  { path: "account/admin/new", element: <AdminAccountRegistration /> },
  { path: "account/admin/view/:id", element: <AdminAccountView /> },
  { path: "account/admin/edit/:id", element: <AdminAccountUpdate /> },
  { path: "account/doctor", element: <DoctorAccount /> },
  { path: "account/doctor/new", element: <DoctorAccountRegistration /> },
  { path: "account/doctor/edit/:id", element: <DoctorAccountUpdate /> },
  { path: "account/doctor/view/:id", element: <DoctorAccountView /> },
  { path: "record", element: <RecordForm /> },
  { path: "record/view/:id", element: <RecordView /> },
  { path: "record/edit/:id", element: <RecordUpdate /> },
  { path: "consultation/new/:patientId", element: <ConsultationWizardWrapper /> },
];


// export const sharedAdminRoutes = [
//   { path: "accueil", element: <DashboardHome /> },
//   { path: "patient", element: <PatientForm /> },
//   { path: "patient/new", element: <Registration /> },
//   { path: "patient/view/:id", element: <PatientAccountView /> },
//   { path: "patient/edit/:id", element: <UpdatePatient /> },
//   { path: "constante", element: <ConstanteForm /> },
//   { path: "constante/new", element: <ConstanteRegistration /> },
//   { path: "constante/view/:id", element: <ConstanteView /> },
//   { path: "constante/edit/:id", element: <ConstanteUpdate /> },
//   { path: "account/patient", element: <PatientAccount /> },
//   { path: "account/patient/new", element: <PatientAccountRegistration /> },
//   { path: "account/patient/view/:id", element: <PatientAccountView /> },
//   { path: "account/patient/edit/:id", element: <PatientAccountUpdate /> },
//   { path: "account/admin", element: <AdminAccount /> },
//   { path: "account/admin/new", element: <AdminAccountRegistration /> },
//   { path: "account/doctor", element: <DoctorAccount /> },
//   { path: "account/doctor/new", element: <DoctorAccountRegistration /> },
//   { path: "account/doctor/edit/:id", element: <DoctorAccountUpdate /> },
//   { path: "account/doctor/view/:id", element: <DoctorAccountView /> },
//   // 🔥 CORRECTION : Utilise maintenant le RecordForm admin
//   { path: "record", element: <RecordForm /> },
//   { path: "record/view/:id", element: <RecordView /> },
//   { path: "record/edit/:id", element: <RecordUpdate /> },
// ];